import moment from "moment";
import { Moment } from "moment";
import { useEffect, useState } from "react";
import Api from "../openapi";
import { checkIf } from "../utils";

export default function useLockedDays() {
  const [lockedDays, setLockedDays] = useState<number>();
  const [lockedStart, setLockedStart] = useState<Moment>();

  useEffect(() => {
    const getLockedDaysForPartner = async () => {
      try {
        const res = await Api.LockedDays.getLockedDaysForActivePartnerAdmin();
        setLockedDays(res.data.lockedDays);
        const startDate = moment()
          .startOf("day")
          .add(Number(res.data.lockedDays) + 1, "days");
        setLockedStart(startDate);
      } catch (error) {}
    };
    getLockedDaysForPartner();
  }, []);
  return { lockedDays, lockedStart };
}
